import { StorageConfig } from "../../Model/StorageConfig";
import { FetchStatus } from "./../../Model/FetchStatus";
import { RootState } from "./RootReducer";
import {
  EFetchStorageConfigAction,
  FetchStorageConfigAction,
} from "../actions/StorageConfigAction";

type State = {
  status: FetchStatus;
  storageConfigs: StorageConfig[];
  storageConfigById: { [index: string]: StorageConfig };
};

const initialState: State = {
  storageConfigs: [],
  storageConfigById: {},
  status: {
    pending: false,
    completed: false,
    error: null,
  },
};

function processStorageConfig(storageconfigs: StorageConfig[]) {
  let storageconfigById: { [index: string]: StorageConfig } = {};

  for (let storageconfig of storageconfigs) {
    storageconfigById[storageconfig.moduleIdentifier] = storageconfig;
  }

  return storageconfigById;
}

export function storageConfigsReducer(
  state = initialState,
  action: FetchStorageConfigAction
): State {
  switch (action.type) {
    case EFetchStorageConfigAction.FETCH_STORAGE_CONFIGS_PENDING:
      return {
        storageConfigs: [],
        storageConfigById: {},
        status: {
          pending: true,
          completed: false,
          error: null,
        },
      };
    case EFetchStorageConfigAction.FETCH_STORAGE_CONFIGS_SUCCESS:
      if (action.storageConfigs == null) {
        throw new Error("StorageConfigs is null");
      }
      const processed = processStorageConfig(action.storageConfigs);
      return {
        storageConfigs: action.storageConfigs,
        storageConfigById: processed,
        status: {
          pending: false,
          completed: true,
          error: null,
        },
      };
    case EFetchStorageConfigAction.FETCH_STORAGE_CONFIGS_ERROR:
      return {
        storageConfigs: [],
        storageConfigById: {},
        status: {
          pending: false,
          completed: true,
          error: action.error,
        },
      };
    default:
      return state;
  }
}

export const selectStorageConfigs = (state: RootState) =>
  state.storageConfigsStore.storageConfigs;

export const getStorageConfig = (
  state: RootState,
  moduleIdentifier: string
): StorageConfig => {
  return state.storageConfigsStore.storageConfigById[moduleIdentifier];
};

export const getStorageConfigById = (
  state: RootState
): { [index: string]: StorageConfig } => {
  return state.storageConfigsStore.storageConfigById;
};

export const getStorageConfigFetchStatus = (state: RootState): FetchStatus =>
  state.storageConfigsStore.status;
